@if (rowType) {
  <div class="d-flex">
    <rask-selector
      label="Välj skogsvård"
      [values]="allSkogsvardGrupp"
      [(ngModel)]="rowType.skogsvardGrupp"
      [disabled]="readonly || !(allSkogsvardGrupp?.length > 0)"
      (change)="skogsvardGruppChanged($event)"
      [required]="true"
      [canDelete]="false">
    </rask-selector>
    @if (visaTypDropdown()) {
      <rask-selector
        label="Välj typ"
        [values]="skogsvardTyper"
        [(ngModel)]="rowType.skogsvardTyp"
        [disabled]="readonly || !(skogsvardTyper?.length > 0)"
        [required]="true"
        [canDelete]="false"
        (change)="skogsvardTypChanged($event)">
      </rask-selector>
    }
    @if (!visaTypDropdown()) {
      <div class="placeholder-selector"
      ></div>
    }
    @if (canDelete) {
      <div class="skogsvard-delete-icon-container">
        <rask-icon-button [disabled]="readonly" (click)="delete()" icon="far fa-trash-alt" negative></rask-icon-button>
      </div>
    }
  </div>
}
